// eslint-disable-next-line no-unused-vars
import axiosInstance from './axiosInstance';

const getMerchantById = (marchantId) =>
  axiosInstance.get(`/internal/admin/merchants/${marchantId}`);

export default getMerchantById;
